"use client";

import { Button } from "../../elements/button/button";

interface FooterScottLogoProps {
  href: string;
  label: string;
}

/** Renders the white SCOTT symbol used by the D2C footer design. */
export function FooterScottLogo(props: Readonly<FooterScottLogoProps>) {
  return (
    <Button
      aria-label={props.label}
      className="h-auto rounded-xs bg-transparent px-0 py-0 text-white shadow-none hover:bg-transparent hover:shadow-none focus-visible:outline-2 focus-visible:outline-current focus-visible:outline-solid focus-visible:outline-offset-4"
      href={props.href}
      unstyled={true}
    >
      <svg
        fill="none"
        height="40"
        role="img"
        viewBox="0 0 29 40"
        width="29"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>SCOTT</title>
        <path
          d="M11.2597 25.6495C11.9077 24.4949 11.9077 23.0928 11.2597 21.8557L8.4245 16.9072C8.18149 16.4949 8.10048 16.0825 8.10048 15.6701C8.10048 15.2577 8.18149 14.8454 8.4245 14.433L11.5837 8.90722C11.5837 8.90722 11.7457 8.49485 12.3937 8.08248C13.0418 7.6701 13.6898 7.6701 13.6898 7.6701H21.4663L25.8405 0H10.2876C8.91053 0 7.69546 0.742268 6.96641 1.81443L1.21507 12.0412C0.405024 13.3608 0 15.0103 0 16.6598C0 18.3918 0.405024 19.8763 1.21507 21.2784L7.45244 32.2474L11.2597 25.6495Z"
          fill="white"
        />
        <path
          d="M27.7849 27.9588C28.595 26.6392 29 24.9897 29 23.3402C29 21.6082 28.595 20.1237 27.7849 18.7216L21.5476 7.75257L17.7403 14.3505C17.0923 15.5051 17.0923 16.9072 17.7403 18.1443L20.5755 23.0928C20.8185 23.5051 20.8995 23.9175 20.8995 24.3299C20.8995 24.7423 20.8185 25.1546 20.5755 25.567L17.4163 31.0928C17.4163 31.0928 17.1733 31.5051 16.6063 31.9175C15.9582 32.3299 15.3102 32.3299 15.3102 32.3299H7.53372L3.15946 40H18.7124C20.0895 40 21.3045 39.2577 22.0336 38.1856L27.7849 27.9588Z"
          fill="white"
        />
      </svg>
    </Button>
  );
}
